<template>
    <div class="w-100" >
        <svg width="0" height="0" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <symbol :id="'deleteItem' + _uid" viewBox="0 0 16 16" class="bi bi-trash" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                </symbol>
                <symbol :id="'editItem' + _uid" class="bi bi-pen" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
                    <path d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z" />
                </symbol>
                <symbol :id="'saveItem' + _uid" class="bi bi-floppy" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
                    <path d="M11 2H9v3h2z"/>
                    <path d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z"/>
                </symbol>
                <symbol :id="'cancelEditItem' + _uid" class="bi bi-arrow-counterclockwise" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
                    <path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"/>
                    <path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"/>
                </symbol>
                <symbol :id="'rejectItem' + _uid" class="bi bi-x-circle" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                </symbol>
                <symbol :id="'acceptItem' + _uid" class="bi bi-check-circle" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
                </symbol>
            </defs>
        </svg>

        <div class="row w-100 m-0">
            <div class="col p-0" >
                <div class="pb-3" style="overflow-x: auto;" >
                <table class="table" >
                    <thead>
                        <tr>
                            <th class="d-none" scope="col">Index</th>
                            <th class="align-middle py-1 td-static-px td-w25" scope="col" >Nazwisko i Imię</th>
                            <th class="align-middle py-1 td-static-px td-w25" scope="col"  >Skrócona nazwa (max. 15)</th>
                            <th class="align-middle text-center py-1 td-static-px td-w10" scope="col"  >HDCP 1r</th>
                            <th class="align-middle text-center py-1 td-static-px td-w10" scope="col" >Bonus</th>
                            <th class="d-none d-md-table-cell col-sm-1 align-middle text-center py-1 td-w15" scope="col">Edytuj</th>
                            <th class="d-none d-md-table-cell col-sm-1 align-middle text-center py-1 td-w10" scope="col">Usuń</th>
                        </tr>
                    </thead>
                    <draggable v-bind:list="sortedPlayersList" v-bind:disabled="((playerDataEditIndex >= 0) || (sortedPlayersList.length < 2)) ? true : false" v-bind="dragOptions" tag="tbody" v-on:start="drag = true" v-on:end="onEndDrag" v-bind:id="'draggable' + _uid" >
                        <!-- <transition-group type="transition" v-bind:name="!drag ? 'flip-list' : null" tag="tbody" css="color: red;" v-bind:id="'transition' + _uid" > -->
                        <tr v-for="(player, index) in sortedPlayersList" :key="'_' + index" v-bind:class="((playerDataEditIndex >= 0) || (sortedPlayersList.length < 2)) ? 'no-drag-item' : 'drag-item'" >
                            <td class="d-none" >@{{ index }}</td>
                            <template v-if="playerDataEditIndex === index">
                                <td class="align-middle py-1 px-1 td-w25" ><input class="form-control" type="text" v-model.lazy.trim="player.name" ></td>
                                <td class="align-middle py-1 px-1 td-w25"  ><input class="form-control" type="text" v-model.lazy.trim="player.shortname" maxlength="15" ></td>
                                <td class="align-middle py-1 px-1 td-w10" ><input class="form-control text-center" type="text" v-model.lazy.number.trim="player.hdcp1r" ></td>
                                <td class="align-middle py-1 px-1 td-w10" ><input class="form-control text-center" type="text" v-model.lazy.number.trim="player.bonus" ></td>
                            </template>
                            <template v-else>
                                <td class="align-middle py-1 td-static-px td-w25" >{{ player.name }}</td>
                                <td class="align-middle py-1 td-static-px td-w25" >{{ player.shortname }}</td>
                                <td class="align-middle py-1 td-static-px text-center td-w10" >{{ player.hdcp1r }}</td>
                                <td class="align-middle py-1 td-static-px text-center td-w10" >{{ player.bonus }}</td>
                            </template>
                            <td class="d-none d-md-table-cell align-middle text-center py-1 td-w15"  >
                                <button type="button" class="btn btn-primary" style="color: #FFFFFF;" v-on:click="editPlayer(index, $event)" >
                                    <svg v-show="(playerDataEditIndex !== index)" width="1.5em" height="1.5em" >
                                        <use :xlink:href="'#editItem' + _uid"></use>
                                    </svg>


                                    <svg v-show="(playerDataEditIndex === index)" width="1.5em" height="1.5em"   >
                                        <use :xlink:href="'#saveItem' + _uid"></use>
                                    </svg>

                                </button>
                                <button v-show="((playerDataEditIndex === index) && (backupData.length > 0))" type="button" class="btn btn-secondary mt-1 mt-lg-0" style="color: #FFFFFF;" v-on:click="cancelEditPlayer(index, $event)" >
                                    <svg width="1.5em" height="1.5em"   >
                                        <use :xlink:href="'#cancelEditItem' + _uid"></use>
                                    </svg>
                                </button>
                            </td>
                            <td class="d-none d-md-table-cell align-middle text-center py-1 td-w10" >
                                <button type="button" class="btn btn-danger" style="color: #FFFFFF;" v-on:click="removePlayer(index)">
                                    <svg width="1.5em" height="1.5em" >
                                        <use :xlink:href="'#deleteItem' + _uid"></use>
                                    </svg>
                                </button>
                            </td>
                        </tr>
                        <!-- </transition-group>  -->
                    </draggable>


                    <tbody v-show="showError" >
                        <tr>

                            <td colspan="5" class="d-table-cell d-md-none align-middle py-1 px-1 td-100" >
                                <div class="alert alert-danger text-center" role="alert">
                                    {{ errorMsg }}
                                </div>
                            </td>
                            <td colspan="7" class="d-none d-md-table-cell align-middle py-1 px-1 td-100" >
                                <div class="alert alert-danger text-center" role="alert">
                                    {{ errorMsg }}
                                </div>
                            </td>

                        </tr>
                    </tbody>

                    <tbody v-bind:id="'addPlayerBody' + _uid" >
                        <tr>
                            <td class="d-none" >#</td>
                            <td class="align-middle py-1 px-1 td-w25" ><input class="form-control" type="text" v-model.trim="newPlayer.name" ></td>
                            <td class="align-middle py-1 px-1 td-w25" ><input class="form-control" type="text" v-model.trim="newPlayer.shortname" maxlength="15" ></td>
                            <td class="align-middle py-1 px-1 td-w10" ><input class="form-control text-center" type="text" v-model.number.trim="newPlayer.hdcp1r" ></td>
                            <td class="align-middle py-1 px-1 td-w10" ><input class="form-control text-center" type="text" v-model.number.trim="newPlayer.bonus" ></td>
                            <td colspan="2" class="d-none d-md-table-cell align-middle py-1 td-w25" ><button type="button" class="btn btn-primary w-100 fw-bold" v-bind:disabled="getDisabledBtnAddPlayer" v-on:click="addPlayer" >Dodaj</button></td>
                        </tr>
                        <tr class="d-table-row d-md-none" >
                            <td colspan="5" class="align-middle py-1 w-100" ><button type="button" class="btn btn-primary w-100 fw-bold" v-bind:disabled="getDisabledBtnAddPlayer" v-on:click="addPlayer" >Dodaj</button></td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.td-w35 {
    width: 35%; max-width: 35%;
}
.td-w25 {
    width: 25%; max-width: 25%;
}
.td-w20 {
    width: 20%; max-width: 20%;
}
.td-w15 {
    width: 15%; max-width: 15%;
}
.td-w10 {
    width: 10%; max-width: 10%;
}
.td-static-px {
    padding-left: 1.15em;
    padding-right: 1.15em;
}
/*
.table {
    background: none #FFFFFF !important;
    color: #000000 !important;
    opacity: 1 !important;
}

td {
    background: none #FFFFFF  !important;
    color: #000000 !important;
    opacity: 1 !important;
} */
.drag-item {
    /* transition: transform 0.25s cubic-bezier(0.02, 1.01, 0.94, 1.01);
    will-change: transform; */
    /* will-change: transform;
    z-index: 1; */
    cursor: grab;
    /*color: #FF0000 !important; */
}

.no-drag-item {
    cursor: default;
}

.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    /* background: #000;
    color: #00FF00; */

    /*font-size: 22px; */
    /* background: #c8ebfb; */
    font-size: 1em !important;
}
.chosen {
  /*opacity: 0.5; */
  /* background: blue;
  color: #FF0000; */
  /* font-size: 34px; */
    font-size: 1em !important;
}
.drag {
  /* opacity: 0.5; */
  background: none #000000 !important;
  /*background: linear-gradient(red 10%, 30%, blue 90%);*/
  font-size: 1.2em !important;
  opacity: 1 !important;
}

.drag > td {
  background: none #000000 !important;


  color: #FFFFFF !important;
  opacity: 0.5 !important;
}

.sortable-ghost {
  border: 1px dashed grey;
  font-size: 0;
  overflow: hidden;
}
@media screen and (max-width: 768px) {
    .td-static-px {
        padding-left: 0.3em;
        padding-right: 0.3em;
    }
    .td-w25 {
        width: 35%; max-width: 35%;
    }
}

</style>

<script>
export default {
    name: "editable-players-list",
    data: function() {
        return {
            newPlayer: {id: -1, name: '', shortname: '', hdcp1r: 0, isPresent: true, bonus: 0, idx: -1},
            drag: false,
            playerDataEditIndex: -1,
            backupData: [],

            statusWait: false,
            errorMsg: '',
            showError: false,
        }
    },
    props: {
        playersList: {
            type: Array,
            required: true,
        }
    },
    computed: {
        dragOptions() {
            return {
                animation: 500,
                group: "description",
                ghostClass: "ghost",
                dragClass: "drag",
                chosenClass: "chosen",

            };
        },
        sortedPlayersList: function() {
            //jednak nie sortujemy tej listy
            /* this.playersList.sort((a, b) => {
                let lastNameA = this.getPlayerLastName(a);
                let lastNameB = this.getPlayerLastName(b);
                if (lastNameA < lastNameB) {
                    return -1;
                }
                if (lastNameA > lastNameB) {
                    return 1;
                }
                return 0;
            }); */
            return this.playersList;
        },
        getDisabledBtnAddPlayer: function() {
            return (((this.newPlayer.name === '') && (this.newPlayer.shortname === '')) || (this.statusWait === true) || (this.newPlayer.hdcp1r === '') || (isNaN(this.newPlayer.hdcp1r)));
        },
    },
    methods: {
        /* getPlayerLastName: function(player) {
            let lastName = '';
            let arrayName = player.name.split(' ');
            if (arrayName.length > 0) {
                lastName = arrayName[0].trim();
            } else {
                arrayName = player.shortname.split(' ');
                if (arrayName.length > 0) {
                    lastName = arrayName[arrayName.length - 1].trim();
                }
            }
            return lastName;
        }, */
        showErrorMsg: function(error) {
            if (typeof error !== 'undefined') {
                if (Array.isArray(error)) {
                    this.errorMsg = '| ';
                    for (let i = 0; i < error.length; i++) {
                        this.errorMsg = this.errorMsg + error[i] + ' |';
                        if (i < error.length - 1) {
                            this.errorMsg = this.errorMsg + ' ';
                        }
                    }
                } else {
                    this.errorMsg = error;
                }
                this.showError = true;
                setTimeout(() => {
                    this.showError = false;
                    this.errorMsg = '';
                }, 15000);
            }
        },
        /* updateIndex: function(oldIndex, newIndex) {
            if (oldIndex > newIndex) {
                for (let i = newIndex; i < this.playersList.length; i++) {
                    console.log(this.playersList[i].name);
                    this.playersList[i].idx = i + 1;
                }
            } else {
                for (let i = newIndex; i = oldIndex; i--) {
                    console.log(this.playersList[i].name);
                    this.playersList[i].idx = i + 1;
                }
            }
        }, */
        onEndDrag: function(param) {
            this.drag = false;
            //oldIndex
            //newIndex

            /*if (param.oldIndex !== param.newIndex) {
                console.log('on end drag');
                console.log(param.oldIndex);
                console.log(param.newIndex);
                this.updateIndex(param.oldIndex, param.newIndex);
                //this.$parent.$emit('editable-players-list-changed');
            } */
        },
        cancelEditPlayer:  function(index, e) {
            let el = e.target;
            while ((el !== undefined) && (el.tagName !== 'BUTTON')) {
                el = el.parentElement;
            }
            if (el !== undefined) {
                el.blur();
            }
            if ((this.playerDataEditIndex >= 0) && (this.playerDataEditIndex < this.playersList.length) && (this.backupData.length > 0)) {
                let tmpPlayer = this.playersList[this.playerDataEditIndex];
                if (tmpPlayer.id === this.backupData[0][0]) {
                    tmpPlayer.name = this.backupData[0][1].name;
                    tmpPlayer.shortname = this.backupData[0][1].shortname;
                    tmpPlayer.hdcp1r = this.backupData[0][1].hdcp1r;
                    tmpPlayer.isPresent = true;
                    tmpPlayer.bonus = this.backupData[0][1].bonus;
                    tmpPlayer.idx = this.backupData[0][1].idx;
                    this.backupData = [];
                }
            }
            this.playerDataEditIndex = -1
        },
        editPlayer:  function(index, e) {
            let el = e.target;
            while ((el !== undefined) && (el.tagName !== 'BUTTON')) {
                el = el.parentElement;
            }
            if (el !== undefined) {
                el.blur();
            }
            if (this.playerDataEditIndex === index) {
                let tmpPlayer = JSON.parse(JSON.stringify(this.playersList[this.playerDataEditIndex]));
                this.$parent.$emit('editable-players-list-changed', JSON.stringify(tmpPlayer), [tmpPlayer.id], 'edit-player',
                    this.editPlayerCalback, this.errorCallBack, true);
            } else {
                let tmpPlayer = JSON.parse(JSON.stringify(this.playersList[index]));
                this.backupData = [];
                this.backupData.push([tmpPlayer.id, JSON.parse(JSON.stringify(tmpPlayer))]);
            }
            (this.playerDataEditIndex === index) ? this.playerDataEditIndex = -1 : this.playerDataEditIndex = index;

        },
        clearPlayers: function() {
            this.playersList = [];
            //this.$parent.$emit('editable-players-list-changed');
        },
        removePlayer: function(index) {

            let tmpPlayer = JSON.parse(JSON.stringify(this.playersList[index]));
            this.backupData = [];
            this.backupData.push([tmpPlayer.id, JSON.parse(JSON.stringify(tmpPlayer))]);

            this.$parent.$emit('editable-players-list-changed', JSON.stringify(tmpPlayer), [tmpPlayer.id], 'delete-player',
                this.deletePlayerCalback, this.errorCallBack, true);
        },
        addPlayerToList: function(player) {
            let tmpPlayer = new Object();
            tmpPlayer = JSON.parse(JSON.stringify(player));


            this.backupData = [];
            this.backupData.push([tmpPlayer.id, JSON.parse(JSON.stringify(tmpPlayer))]);

            tmpPlayer.idx = this.playersList.length;
            this.$parent.$emit('editable-players-list-changed', JSON.stringify(tmpPlayer), [tmpPlayer.id], 'create-new-player',
                this.addPlayerCalback, this.errorCallBack, true);
        },
        addPlayer: function(e) {
            this.statusWait = true;
            this.showError = false;
            this.errorMsg = '';

            this.addPlayerToList(this.newPlayer);
            this.newPlayer.id = -1;
            this.newPlayer.name = '';
            this.newPlayer.shortname = '';
            this.newPlayer.hdcp1r = 0;
            this.newPlayer.isPresent = true;
            this.newPlayer.bonus = 0;
            this.newPlayer.idx = this.playersList.length;
            if (e != undefined) {
                e.preventDefault();
            }
        },
        errorCallBack: function(error, action, alwaysFalse) {
            this.showErrorMsg(error);
            if (this.backupData.length > 0) {
                switch (action) {
                case 'create-new-player':
                    this.newPlayer = JSON.parse(JSON.stringify(this.backupData[0][1]));
                    break;
                case 'edit-player':
                    let id = this.backupData[0][0];

                    let tmpPlayer = JSON.parse(JSON.stringify(this.backupData[0][1]));
                    let found = this.playersList.filter((item) => { return item.id === id; });
                    if ((typeof found !== 'undefined') && (Array.isArray(found)) && (found.length === 1)) {
                        //found[0] = tmpPlayer not work playerLlist not refresh
                        found[0].name = tmpPlayer.name;
                        found[0].shortname = tmpPlayer.shortname;
                        found[0].hdcp1r = tmpPlayer.hdcp1r;
                        found[0].isPresent = true;
                        found[0].bonus = tmpPlayer.bonus;
                        found[0].idx = tmpPlayer.idx;
                    }
                    break;
                case 'delete-player':
                    break;
                default:
                    console.log(`Jeszcze nie zdefiniowano przywracania kopii dla ${action}.`);
                }
            }
            this.backupData = [];
            this.statusWait = false;
        },
        deletePlayerCalback: function(player, action) {
            let index = -1;
            let found = this.playersList.find(function(item, i){
                if(item.id === player.id){
                    index = i;
                    return i;
                }
            });

            if (index >= 0) {
                this.playersList.splice(index, 1);
                console.log(index);
            }

            this.statusWait = false;
        },
        editPlayerCalback: function(player, action) {
            this.statusWait = false;
        },
        addPlayerCalback: function(player, action) {
            this.playersList.push(JSON.parse(JSON.stringify(player)));
            this.statusWait = false;
        }

    },
    mounted() {
        console.log("component editable-playeers-list mounted");
    }
};
</script>
